import React from 'react';
import SectionHeader from './SectionHeader';

export default function About() {
  const highlights = [
    { value: '2+', label: 'Years Experience', icon: '💼' },
    { value: '1st', label: 'DaaS Hackathon', icon: '🏆' },
  ];

  return (
    <section id="about" style={{ padding: '7rem 0' }}>
      <div className="section-container">
        <SectionHeader
          label="About Me"
          title="Crafting Modern Web Experiences"
        />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem',
            marginTop: '3rem',
          }}
        >
          {/* About Text */}
          <div
            className="glass-card"
            style={{ padding: '2rem', gridColumn: 'span 1' }}
          >
            <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8, fontSize: '1rem', marginBottom: '1.25rem' }}>
              Frontend developer with expertise in{' '}
              <span style={{ color: 'var(--accent-violet-light)', fontWeight: 600 }}>React.js, Next.js, and TypeScript</span>,
              currently driving UI modernization at Kaiburr. Proven track record in migrating legacy applications to
              modern component-based architectures and engineering high-performance data grids for large-scale automation datasets.
            </p>
            <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8, fontSize: '1rem' }}>
              Skilled in performance optimization, complex state management, and developing interactive{' '}
              <span style={{ color: 'var(--accent-cyan)', fontWeight: 600 }}>data visualizations</span>.
              Recipient of{' '}
              <span style={{ color: 'var(--accent-emerald)', fontWeight: 600 }}>1st Place in the DaaS Voice AI Hackathon</span>{' '}
              for innovative chatbot development.
            </p>
          </div>

          {/* Highlights Grid */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1rem',
            }}
          >
            {highlights.map((item, i) => (
              <div
                key={i}
                className="glass-card"
                style={{
                  padding: '1.5rem',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                }}
              >
                <span style={{ fontSize: '1.75rem' }}>{item.icon}</span>
                <span
                  className="gradient-text"
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: '1.75rem',
                    fontWeight: 800,
                  }}
                >
                  {item.value}
                </span>
                <span
                  style={{
                    fontSize: '0.8rem',
                    color: 'var(--text-muted)',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                  }}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
